export const getFileNameFromURI = (uri: string) => {
  const uriParts = uri.split('/')
  return uriParts[uriParts.length - 1]
}

export const download = (url: string, filename?: string) => {
  window.onbeforeunload = () => null
  const downloadFileName = filename
    ? getFileNameFromURI(filename)
    : getFileNameFromURI(new URL(url).pathname)
  const anchor = document.createElement('a')
  anchor.setAttribute('href', url)
  anchor.setAttribute('download', downloadFileName)
  anchor.click()
}
